import React from 'react';
import { Tooltip, Typography } from 'antd';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
} from '../../../../../shared/lib/toggleModalVisble';
import { useShutdownAccesses } from '../../../../../shared/lib/hooks/useShutdownAccesses';

const { Text } = Typography;

const Content = ({ description, shutdown }) => {
  const { canChange } = useShutdownAccesses();

  const dispatch = useModalDispatch();

  const handleClick = (e) => {
    e.stopPropagation();

    if (!canChange) return;

    dispatch({
      type: modalActionTypes.setModalData,
      payload: {
        type: modalTypes.changeShutdownDesc,
        initialValues: shutdown,
      },
    });
  };

  return (
    <Tooltip
      title={!canChange ? '' : description?.trim() ? 'Изменить' : 'Добавить'}
    >
      <Text onClick={handleClick}>{description || 'Не указано'}</Text>
    </Tooltip>
  );
};

export default Content;
